import { exportHistory } from './ExportHistory/ExportHistory.i18n.en'

export const attendanceLogs = {
  title: 'Matching data',
  exportHistory,
}
